import React from 'react';

/**
 * Renders the standard AI disclaimer line below every AI result panel.
 * @param {Object} props
 * @param {string} props.dataAsOf    - ISO 8601 timestamp string
 * @param {string} [props.earlyAccess] - Optional early-access notice rendered above the disclaimer
 */
export default function AiDisclaimer({ dataAsOf, earlyAccess }) {
  const formatted = dataAsOf
    ? new Date(dataAsOf).toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '—';

  return (
    <>
      {earlyAccess && <p className="ai-early-access">{earlyAccess}</p>}
      <p className="ai-disclaimer">
        AI suggestion · Data as of {formatted}
      </p>
    </>
  );
}
